import axiosInstance from '../../redux/axiosInstance';

class TaxServiceQuestionService {
  listQuestions(page = 1, perPage = 20) {
    return axiosInstance.get('/tax-service-questions/list', { params: { page, perPage } });
  }

  listByTaxService(taxServiceId, page = 1, perPage = 20) {
    return axiosInstance.get(`/tax-service-questions/list/service/${taxServiceId}`, { params: { page, perPage } });
  }

  getById(id) {
    return axiosInstance.get(`/tax-service-questions/view/${id}`);
  }

  createQuestion(data) {
    return axiosInstance.post('/tax-service-questions/admins/create', data);
  }

  updateQuestion(id, data) {
    return axiosInstance.patch(`/tax-service-questions/admins/update/${id}`, data);
  }

  deleteQuestion(id) {
    return axiosInstance.delete(`/tax-service-questions/admins/delete/${id}`);
  }
}

export default new TaxServiceQuestionService();
